/*
 * Calmont Schlafberater: Popup mit 3 Fragen, Profil in localStorage („calSleepProfile“),
 * Ergebnis mit passender Kissenhöhe und Produkten, Markierung „Passt zu dir“ auf Produktkarten
 * und Hinweis auf der Produktseite. Löst nach dem Speichern das Event „cal:sleep-profile“ aus.
 */
(() => {
  const KEY = 'calSleepProfile';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } };
  const write = (p) => { try { localStorage.setItem(KEY, JSON.stringify(p)); } catch (e) {} };
  // Tracking: dataLayer (GA4/GTM), Shopify-Kundenereignisse und Clarity; Kauf-Zuordnung über das Warenkorb-Attribut „_schlafberater“
  const track = (name, data = {}) => {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish(name, data); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  };
  const tagCart = (p, quelle) => {
    if (!p) return;
    const v = [p.pos || '-', p.firm || '-', p.temp || '-'].join('/') + ' · ' + quelle;
    try { if (sessionStorage.getItem('calFdCart') === v) return; sessionStorage.setItem('calFdCart', v); } catch (e) {}
    try { if (typeof window.clarity === 'function') window.clarity('set', 'schlafberater', quelle); } catch (e) {}
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _schlafberater: v } }) }).catch(() => {});
  };
  const POS = { seite: 'Seitenschläfer', ruecken: 'Rückenschläfer', bauch: 'Bauchschläfer', wechsel: 'Wechselschläfer' };
  const TEMP = { kalt: 'fröstelig', neutral: 'ausgeglichen', warm: 'warm' };
  const POS_WHY = {
    seite: 'In Seitenlage liegt die Schulterbreite zwischen Kopf und Matratze. Ein höheres Kissen hält die Halswirbelsäule gerade.',
    ruecken: 'In Rückenlage braucht der Nacken Stütze, der Kopf aber wenig Höhe, sonst knickt er nach vorn.',
    bauch: 'In Bauchlage sollte der Kopf möglichst flach liegen, damit der Nacken nicht überstreckt.',
    wechsel: 'Wer die Lage wechselt, braucht beides: mehr Höhe für die Seite, weniger für den Rücken.'
  };
  const FIRM_WHY = { weich: 'Der Kopf darf etwas einsinken, die Höhe sollte trotzdem stimmen.', mittel: 'Halt für den Nacken, ohne hart zu liegen.', fest: 'Ein formstabiles Nackenstützkissen hält den Kopf ruhig.' };
  const TEMP_WHY = { kalt: 'Du frierst schnell: Eine Daunendecke hält die Wärme.', neutral: 'Eine Daunendecke für das ganze Jahr passt meist am besten.', warm: 'Dir wird schnell warm: leichte, atmungsaktive Decken statt dicker Daunen.' };
  const H = {
    seite: [false, true, 'Hohe Seite · 14 cm', 'Füllt den Abstand zwischen Schulter und Kopf.'],
    ruecken: [true, false, 'Niedrige Seite · 11 cm', 'Stützt den Nacken, ohne den Kopf anzuheben.'],
    bauch: [true, false, 'Niedrig · 11 cm', 'Der Kopf liegt möglichst flach.'],
    wechsel: [true, true, 'Beide Höhen · 11 und 14 cm', 'Ein Kissen mit zwei Höhen, einfach wenden.']
  };
  const ASIDE = [
    ['Schlafberater', 'Drei Fragen. Danach markieren wir im Shop, was zu dir passt.'],
    ['Warum das zählt', 'Die Schlaflage bestimmt, wie hoch dein Kissen sein sollte.'],
    ['Gut zu wissen', 'Höhe und Festigkeit entscheiden am häufigsten darüber, ob ein Kissen passt.'],
    ['Gut zu wissen', 'Die passende Decke richtet sich nach deinem Wärmeempfinden.']
  ];
  const label = (p) => [POS[p.pos || 'wechsel'], p.firm, p.temp ? TEMP[p.temp] : ''].filter(Boolean).join(' · ');


  // Profil aus dem E-Mail-Link übernehmen: ?schlaftyp=seite-fest-warm (Teile optional, „x“ = offen)
  (() => {
    try {
      const u = new URL(location.href); const v = u.searchParams.get('schlaftyp'); if (!v) return;
      const [pos, firm, temp] = v.toLowerCase().split('-');
      const ok = (x, list) => (list.includes(x) ? x : null);
      const p = { pos: ok(pos, ['seite', 'ruecken', 'bauch', 'wechsel']), firm: ok(firm, ['weich', 'mittel', 'fest']), temp: ok(temp, ['kalt', 'neutral', 'warm']), t: Date.now() };
      if (p.pos || p.firm || p.temp) write(p);
      u.searchParams.delete('schlaftyp'); history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  })();

  let MAP = { fitLabel: 'Passt zu dir', pdpYes: 'Passt zu deinem Schlaftyp', pdpNo: 'Für deinen Schlaftyp gibt es Passenderes' };
  const fitHandles = (p) => {
    if (!p) return [];
    return [].concat(MAP[p.pos || 'wechsel'] || [], MAP[p.temp || 'neutral'] || []);
  };
  const allHandles = () => ['seite', 'ruecken', 'bauch', 'wechsel', 'kalt', 'neutral', 'warm'].flatMap((k) => MAP[k] || []);
  const handleOf = (href) => { const m = (href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; };

  // Markierung auf Produktkarten (Calmont-Karten + Horizon-Karten) und Produktseite
  function mark() {
    const p = read();
    const fit = new Set(fitHandles(p));
    document.querySelectorAll('.cal-fit-chip').forEach((n) => n.remove());
    if (p) {
      const cards = document.querySelectorAll('a.cal-xs__card, product-card a[href*="/products/"], .product-card a[href*="/products/"], a.cal-cart-card__media');
      const done = new Set();
      cards.forEach((a) => {
        const h = handleOf(a.getAttribute('href'));
        if (!h || !fit.has(h)) return;
        const host = a.closest('.cal-xs__card') || a.closest('.cal-cart-card') || a.closest('product-card') || a.closest('.product-card') || a;
        if (done.has(host) || host.closest('.cal-fd')) return;
        done.add(host);
        const media = host.querySelector('.cal-xs__m, .cal-cart-card__media, .card-gallery, .product-card__image, slideshow-component') || host;
        const chip = document.createElement('span');
        chip.className = 'cal-fit-chip';
        chip.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
        chip.append(MAP.fitLabel);
        if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
        media.appendChild(chip);
      });
    }
    document.querySelectorAll('[data-cal-fit-pdp]').forEach((el) => {
      const h = el.getAttribute('data-cal-fit-pdp');
      if (!p || !allHandles().includes(h)) { el.hidden = true; return; }
      const pos = p.pos || 'wechsel'; const temp = p.temp || 'neutral';
      const isPillow = ['seite', 'ruecken', 'bauch', 'wechsel'].some((k) => (MAP[k] || []).includes(h));
      const yes = fit.has(h);
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const REC = { seite: 'Nutze die hohe Seite (14 cm).', ruecken: 'Nutze die niedrige Seite (11 cm).', bauch: 'Nutze die niedrige Seite (11 cm).', wechsel: 'Probiere beide Höhen (11 und 14 cm) aus.' };
      const TREC = { kalt: 'Hält die Wärme, ohne dass du schwitzt.', neutral: 'Passt für das ganze Jahr.', warm: 'Leicht und atmungsaktiv für warme Nächte.' };
      let html;
      if (yes) {
        const rec = isPillow ? REC[pos] : TREC[temp];
        const why = isPillow ? POS_WHY[pos] : TEMP_WHY[temp];
        html = '<span class="cal-fitbox__ic"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></span><div class="cal-fitbox__b"><div class="cal-fitbox__h"><b>' + esc(MAP.pdpYes) + '</b><span>' + esc(label(p)) + '</span></div><p class="cal-fitbox__rec"><strong>' + esc(rec) + '</strong></p><p class="cal-fitbox__why">' + esc(why) + '</p><div class="cal-fitbox__links"><button type="button" data-cal-finder-open>Schlaftyp ändern</button></div></div>';
      } else {
        const pool = isPillow ? (MAP[pos] || []) : (MAP[temp] || []);
        const alts = pool.filter((x) => x !== h).slice(0, 2).map((x) => {
          const card = document.querySelector('.fd-rp[data-handle="' + CSS.escape(x) + '"]');
          if (!card) return '';
          const img = card.querySelector('img'); const t = card.querySelector('.fd-rp__t'); const pr = card.querySelector('.fd-rp__p');
          return '<a href="' + esc(card.getAttribute('href')) + '">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="">' : '<span></span>') + '<span><b>' + esc(t ? t.textContent.trim() : x) + '</b></span><em>' + esc(pr ? pr.textContent.trim() : '') + '</em></a>';
        }).join('');
        const why = isPillow ? 'Für ' + (POS[pos] || 'deine Schlaflage') + ' passen eher:' : (temp === 'warm' ? 'Dir wird nachts schnell warm. Eher passend:' : temp === 'kalt' ? 'Du frierst nachts schnell. Eher passend:' : 'Für dein Wärmeempfinden passen eher:');
        html = '<span class="cal-fitbox__ic"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 11v5M12 7.8v.4"/></svg></span><div class="cal-fitbox__b"><div class="cal-fitbox__h"><b>' + esc(MAP.pdpNo) + '</b><span>' + esc(label(p)) + '</span></div><p class="cal-fitbox__why">' + esc(why) + '</p>' + (alts ? '<div class="cal-fitbox__alt">' + alts + '</div>' : '') + '<div class="cal-fitbox__links"><button type="button" data-cal-finder-open>Schlaftyp ändern</button></div></div>';
      }
      el.className = 'cal-fitbox ' + (yes ? 'is-yes' : 'is-no');
      el.innerHTML = html;
      el.hidden = false;
    });
    document.querySelectorAll('[data-fab-txt]').forEach((t) => { t.textContent = p ? t.dataset.saved : t.dataset.default; });
    document.querySelectorAll('.cal-fd__fab').forEach((f) => f.classList.toggle('has-profile', !!p));
  }

  // Öffentliche Schnittstelle, z. B. für den Filter „Nur passende zeigen“ auf der Kategorieseite
  window.CalSleep = {
    profile: read,
    fits: (handle) => fitHandles(read()).includes(handle),
    handles: () => fitHandles(read()),
    open: () => { const f = document.querySelector('cal-finder'); if (f) f.open(); },
    // Für die Ergebnis-Seite: Gruppen, Text und Kissenhöhe zum aktuellen Profil
    groups: () => { const p = read(); return p ? { pillow: (MAP[p.pos || 'wechsel'] || []).slice(), blanket: (MAP[p.temp || 'neutral'] || []).slice() } : null; },
    info: () => {
      const p = read(); if (!p) return null; const pos = p.pos || 'wechsel';
      const why = [['Schlaflage', POS_WHY[pos]]];
      if (p.firm) why.push(['Festigkeit ' + p.firm, FIRM_WHY[p.firm]]);
      why.push(['Wärme', TEMP_WHY[p.temp || 'neutral']]);
      return { label: label(p), height: H[pos], why, profile: p };
    }
  };

  class CalFinder extends HTMLElement {
    connectedCallback() {
      try { MAP = Object.assign(MAP, JSON.parse(this.querySelector('[data-cal-fd-map]').textContent)); } catch (e) {}
      this.dlg = this.querySelector('dialog');
      this.state = Object.assign({ pos: null, firm: null, temp: null }, read() || {});
      this.step = 0;
      this.addEventListener('click', (e) => this.onClick(e));
      const mf = this.querySelector('[data-mail]');
      if (mf) mf.addEventListener('submit', (e) => { e.preventDefault(); this.sendMail(mf); });
      this.dlg.addEventListener('click', (e) => { if (e.target === this.dlg) this.close(); });
      this.dlg.addEventListener('close', () => document.documentElement.classList.remove('cal-fd-open'));
      document.addEventListener('click', (e) => {
        const t = e.target.closest('[data-cal-finder-open], a[href$="#schlafberater"]');
        if (t && !this.contains(t)) { e.preventDefault(); this.open(); }
        else if (t && this.contains(t) && !this.dlg.contains(t)) { e.preventDefault(); this.open(); }
      });
      if (location.hash === '#schlafberater') this.open();
      const auto = +this.dataset.auto || 0;
      if (auto && !read()) { try { if (!sessionStorage.getItem('calFdSeen')) setTimeout(() => { if (!read()) this.open(); }, auto * 1000); sessionStorage.setItem('calFdSeen', '1'); } catch (e) {} }
      mark();
      // Button erst einblenden, wenn der erste Bereich (Hero/Kopf) weggescrollt ist; am Seitenende (Footer) wieder
      // ausblenden, damit er Zahlungs-Icons und Links nicht überdeckt. „×“ blendet ihn für diese Sitzung aus.
      const wrap = this.querySelector('[data-fabw]');
      if (wrap) {
        // „ד verkleinert den Button zu einem runden Mond-Symbol (bleibt auffindbar), gemerkt im Browser
        let mini = false; try { mini = localStorage.getItem('calFdFabMini') === '1'; } catch (e) {}
        wrap.classList.toggle('is-mini', mini);
        const st = { hero: true, foot: false };
        const upd = () => wrap.classList.toggle('is-in', !st.hero && !st.foot);
        const main = document.querySelector('main');
        const first = main && (main.querySelector(':scope > .shopify-section, :scope > section, :scope > div') || main);
        if ('IntersectionObserver' in window && first) {
          new IntersectionObserver((es) => { es.forEach((e) => { st.hero = e.isIntersecting; }); upd(); }, { rootMargin: '-80px 0px 0px 0px' }).observe(first);
          const feet = [...document.querySelectorAll('footer > .shopify-section')].filter((n) => !n.contains(this));
          const seen = new Map();
          const io = new IntersectionObserver((es) => { es.forEach((e) => seen.set(e.target, e.isIntersecting)); st.foot = [...seen.values()].some(Boolean); upd(); });
          feet.forEach((n) => io.observe(n));
        } else { st.hero = false; upd(); }
        wrap.querySelector('[data-fab-x]').addEventListener('click', () => { wrap.classList.add('is-mini'); try { localStorage.setItem('calFdFabMini', '1'); } catch (e) {} });
      }
      document.dispatchEvent(new CustomEvent('cal:sleep-ready'));
      if (read()) tagCart(read(), 'profil');
      document.addEventListener('shopify:section:load', mark);
      new MutationObserver(() => { clearTimeout(this._mt); this._mt = setTimeout(mark, 150); }).observe(document.body, { childList: true, subtree: true });
    }
    open() {
      track('schlafberater_geoeffnet', { schlafberater_profil: read() ? 'ja' : 'nein' });
      const saved = read();
      this.show(saved ? 4 : 0);
      if (!this.dlg.open) this.dlg.showModal();
      document.documentElement.classList.add('cal-fd-open');
    }
    close() { if (this.dlg.open) this.dlg.close(); }
    show(step) {
      this.step = step;
      const q = this.querySelector('[data-fd-q]'); const r = this.querySelector('[data-fd-r]');
      q.hidden = step === 4; r.hidden = step !== 4;
      this.dlg.classList.toggle('is-res', step === 4);
      q.querySelectorAll('[data-view]').forEach((v) => { v.hidden = +v.dataset.view !== step; });
      const inQ = step >= 1 && step <= 3;
      this.querySelector('[data-nav]').hidden = !inQ;
      this.querySelector('[data-back]').disabled = false;
      this.querySelectorAll('[data-top-0]').forEach((n) => { n.hidden = inQ; });
      this.querySelectorAll('[data-top-q]').forEach((n) => { n.hidden = !inQ; });
      this.querySelector('[data-step-txt]').textContent = 'Frage ' + step + ' von 3';
      this.querySelectorAll('.fd-prog i').forEach((i, n) => i.classList.toggle('is-on', step > n));
      const a = Math.min(step, 3);
      this.querySelectorAll('[data-as]').forEach((f) => { f.hidden = +f.dataset.as !== a; });
      const av = this.querySelector('[data-view="' + a + '"]');
      this.querySelector('[data-as-k]').textContent = (av && av.dataset.ak) || ASIDE[a][0];
      this.querySelector('[data-as-t]').textContent = (av && av.dataset.at) || ASIDE[a][1];
      this.querySelectorAll('[data-k][data-v]').forEach((o) => o.setAttribute('aria-checked', String(this.state[o.dataset.k] === o.dataset.v)));
      if (step === 1 && !this._started) { this._started = true; track('schlafberater_start'); }
      if (step === 4) { this.result(); this.savedUi(); track('schlafberater_ergebnis', { schlaflage: this.state.pos || '', festigkeit: this.state.firm || '', waerme: this.state.temp || '' }); tagCart(this.state, 'ergebnis'); }
      const f = step === 4 ? r.querySelector('.cal-btn') : step === 0 ? this.querySelector('[data-view="0"] .cal-btn') : null;
      if (f && this.dlg.open) f.focus({ preventScroll: true });
    }
    result() {
      const p = this.state; const pos = p.pos || 'wechsel';
      this.querySelector('[data-type-label]').textContent = label(p);
      const h = H[pos];
      this.querySelector('[data-h-lo]').classList.toggle('is-on', h[0]);
      this.querySelector('[data-h-hi]').classList.toggle('is-on', h[1]);
      this.querySelector('[data-h-title]').textContent = h[2];
      this.querySelector('[data-h-sub]').textContent = h[3];
      const why = [['Schlaflage', POS_WHY[pos]]];
      if (p.firm) why.push(['Festigkeit ' + p.firm, FIRM_WHY[p.firm]]);
      why.push(['Wärme', TEMP_WHY[p.temp || 'neutral']]);
      const ul = this.querySelector('[data-why]'); ul.innerHTML = '';
      why.forEach(([b, t]) => {
        const li = document.createElement('li');
        li.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
        const sp = document.createElement('span'); const s = document.createElement('b'); s.textContent = b + ':'; sp.append(s, ' ' + t); li.append(sp); ul.append(li);
      });
      const pil = MAP[pos] || []; const dec = MAP[p.temp || 'neutral'] || [];
      const PIL_W = { seite: 'Hohe Seite (14 cm) nutzen', ruecken: 'Niedrige Seite (11 cm) nutzen', bauch: 'Flach liegen, niedrige Seite nutzen', wechsel: 'Beide Höhen, einfach wenden' };
      const DEC_W = { kalt: 'Hält die Wärme, auch in kalten Nächten', neutral: 'Warm ohne Hitzestau, für das ganze Jahr', warm: 'Leicht und atmungsaktiv, kein Hitzestau' };
      const box = this.querySelector('[data-prods]');
      box.querySelectorAll('[data-handle]').forEach((n) => { n.hidden = true; n.style.order = ''; n.classList.remove('is-last'); });
      const list = [].concat(pil.slice(0, 2).map((hd) => [hd, PIL_W[pos]]), dec.slice(0, 2).map((hd) => [hd, DEC_W[p.temp || 'neutral']]));
      let shown = 0; let last = null;
      list.forEach(([hd, w], i) => {
        const n = box.querySelector('[data-handle="' + CSS.escape(hd) + '"]');
        if (n && n.hidden) { n.hidden = false; n.style.order = i; n.querySelector('[data-w]').textContent = w || ''; shown++; last = n; }
      });
      if (last) last.classList.add('is-last');
      this.querySelector('[data-prod-count]').textContent = shown + (shown === 1 ? ' Produkt' : ' Produkte');
    }
    // gespeichert = Antworten entsprechen dem gespeicherten Profil
    isSaved() {
      const r = read(); if (!r) return false;
      return ['pos', 'firm', 'temp'].every((k) => (r[k] || null) === (this.state[k] || null));
    }
    savedUi() {
      const ok = this.isSaved();
      const b = this.querySelector('[data-save]'); if (b) b.hidden = ok;
      const n = this.querySelector('[data-saved-note]'); if (n) n.hidden = !ok;
    }
    save() {
      const p = { pos: this.state.pos, firm: this.state.firm, temp: this.state.temp, t: Date.now() };
      write(p);
      mark();
      document.dispatchEvent(new CustomEvent('cal:sleep-profile', { detail: p }));
      track('schlafberater_gespeichert');
      this.savedUi();
    }
    // Ergebnis per E-Mail über Klaviyo (Client-API, öffentlicher Schlüssel aus dem Klaviyo-Onsite-Skript)
    klaviyoId() {
      const sc = [...document.scripts].map((x) => x.src).find((x) => /klaviyo\.com\/onsite\/js\/.*company_id=/.test(x) || /static\.klaviyo\.com.*company_id=/.test(x));
      const m = sc && sc.match(/company_id=([A-Za-z0-9]+)/);
      return m ? m[1] : (window._klOnsite && window._klOnsite.company_id) || 'VXLhjy'; // Fallback: öffentlicher Klaviyo-Schlüssel von Calmont, solange das App-Embed im Theme fehlt
    }
    async sendMail(form) {
      const msg = form.querySelector('[data-mail-msg]'); const btn = form.querySelector('button');
      const show = (t, err) => { msg.hidden = false; msg.textContent = t; msg.classList.toggle('is-err', !!err); };
      const email = form.email.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { show('Bitte gib eine gültige E-Mail-Adresse ein.', true); form.email.focus(); return; }
      const cid = this.klaviyoId();
      if (!cid) { show('Der Versand ist gerade nicht möglich. Bitte versuche es später noch einmal.', true); return; }
      if (!this.isSaved()) this.save();
      const p = this.state; const pos = p.pos || 'wechsel';
      const code = [p.pos || 'x', p.firm || 'x', p.temp || 'x'].join('-');
      const base = (this.dataset.shopUrl || location.origin).replace(/\/$/, '');
      const prods = [...this.querySelectorAll('[data-prods] [data-handle]:not([hidden])')].map((n) => ({
        title: (n.querySelector('.fd-rp__t') || {}).textContent || '', price: (n.querySelector('.fd-rp__p') || {}).textContent || '',
        url: base + n.getAttribute('href'), image: ((n.querySelector('img') || {}).src || '').replace(/^\/\//, 'https://'), reason: (n.querySelector('[data-w]') || {}).textContent || ''
      }));
      const props = {
        schlaftyp: label(p), schlaflage: p.pos || '', festigkeit: p.firm || '', waerme: p.temp || '',
        kissenhoehe: H[pos][2], kissenhoehe_text: H[pos][3], produkte: prods, link: base + '/collections/all?view=schlaftyp&schlaftyp=' + code
      };
      const H2 = { 'Content-Type': 'application/json', revision: '2025-01-15' };
      btn.disabled = true;
      try {
        const list = (this.dataset.list || '').trim();
        if (list) {
          await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + cid, { method: 'POST', headers: H2, body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Schlafberater', profile: { data: { type: 'profile', attributes: { email, properties: { calmont_schlaftyp: props.schlaftyp, calmont_schlaftyp_link: props.link } } } } }, relationships: { list: { data: { type: 'list', id: list } } } } }) });
        }
        const r = await fetch('https://a.klaviyo.com/client/events/?company_id=' + cid, { method: 'POST', headers: H2, body: JSON.stringify({ data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: 'Schlafberater Ergebnis' } } }, profile: { data: { type: 'profile', attributes: { email } } } } } }) });
        if (!r.ok) throw new Error(r.status);
        show(list ? 'Fast geschafft: Bitte bestätige deine Anmeldung in der E-Mail, die wir dir gerade geschickt haben. Danach kommt dein Ergebnis.' : 'Danke! Dein Ergebnis ist unterwegs.');
        form.querySelector('.fd-mail__row').hidden = true;
        track('schlafberater_mail');
      } catch (e) {
        show('Das hat nicht geklappt. Bitte versuche es noch einmal.', true);
      }
      btn.disabled = false;
    }
    onClick(e) {
      const t = e.target.closest('button, a'); if (!t || !this.dlg.contains(t)) return;
      if (t.matches('a') && t.closest('[data-prods]')) { const n = t.closest('[data-handle]'); track('schlafberater_produkt_klick', { produkt: n ? n.dataset.handle : '' }); }
      if (t.matches('[data-cal-finder-close]')) { this.close(); return; }
      if (t.matches('[data-cal-finder-close-nav]')) { if (this.step === 4 && !this.isSaved()) this.save(); this.close(); return; }
      if (t.dataset.go) { this.show(+t.dataset.go); return; }
      if (t.matches('[data-back]')) { this.show(Math.max(0, this.step - 1)); return; }
      if (t.matches('[data-skip]')) { const n = Math.min(4, this.step + 1); this.show(n); return; }
      if (t.matches('[data-save]')) { this.save(); return; }
      if (t.matches('[data-restart]')) { this.state = { pos: null, firm: null, temp: null }; this.show(1); return; }
      if (t.matches('[data-k][data-v]')) {
        this.state[t.dataset.k] = t.dataset.v;
        const n = this.step + 1;
        setTimeout(() => this.show(n), 160);
        t.setAttribute('aria-checked', 'true');
      }
    }
  }
  if (!customElements.get('cal-finder')) customElements.define('cal-finder', CalFinder);
})();
